import { Box, Divider, Link, Menu, MenuItem } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { routes } from 'shared/routes';
import { colors } from 'shared/styles/constants';
import { useLogoutAction } from 'shared/utils/hooks/useLogoutAction';
import { impersonateSwitchBack } from 'store/components/auth/authActions';
import { selectCurrentUser, selectIsUserImpersonate } from 'store/components/auth/selectors';
import { IStore } from 'store/configureStore';
import { useUserHeaderStyles } from './headerUserStyles';

interface IHeaderUserMenu {
    anchorEl: HTMLElement | null;
    handleClose: () => void;
}

const HeaderUserMenu = ({ anchorEl, handleClose }: IHeaderUserMenu) => {
    const { isAuthenticated } = useSelector((state: IStore) => state.auth);
    const dispatch = useDispatch();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const isUserImpersonate = useSelector(selectIsUserImpersonate);
    const logout = useLogoutAction();

    const handleLogout = useCallback(() => {
        dispatch(logout());
        handleClose();
    }, [dispatch, handleClose, logout]);
    const handleImpersonateSwitchBack = useCallback(() => {
        dispatch(impersonateSwitchBack.init());
        handleClose();
    }, [dispatch, handleClose]);
    const headerClasses = useUserHeaderStyles();
    const currentUser = useSelector(selectCurrentUser);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars

    return (
        <Menu
            id="header-user-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            getContentAnchorEl={null}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            classes={{ paper: headerClasses.profileMenu }}
        >
            {isAuthenticated
                && (
                    <Box>
                        <section className={headerClasses.Title}>
                            {currentUser?.firstName} {currentUser?.lastName}
                        </section>
                        <Divider
                            classes={{ root: `${headerClasses.divider}` }}
                            orientation="horizontal"
                        />
                        {!isUserImpersonate && (
                            <MenuItem
                                component={NavLink}
                                to={routes.USER_PROFILE}
                                onClick={handleClose}>
                                User Profile
                            </MenuItem>
                        )}
                        {isUserImpersonate && (
                            <MenuItem onClick={handleImpersonateSwitchBack} style={{ color: colors.darkBlue }}>
                                Switch Back
                            </MenuItem>
                        )}
                        {/*
                            TODO: Implement Notification Setting, bun now this inactive menu item can confuse user
                            <MenuItem>Notification Settings</MenuItem>
                        */}
                        <MenuItem onClick={handleLogout}>Log out</MenuItem>
                    </Box>
                )
            }
            {!isAuthenticated && <MenuItem><Link href={routes.AUTH.LOGIN}>Login</Link></MenuItem>}
        </Menu>
    );
};

export default HeaderUserMenu;
